// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GaB00U4_7SkZPKkRaGt9{min-height:20px;color:var(--content-negative-primary);align-items:center;gap:4px;display:flex}.bvYQTa7jB04YqNkm5AZM{line-height:16px}.s7hY7EOq47UpaP9_RKKV a{color:var(--content-brand-primary);text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `GaB00U4_7SkZPKkRaGt9`,
	"text": `bvYQTa7jB04YqNkm5AZM`,
	"errorHtml": `s7hY7EOq47UpaP9_RKKV`
};
export default ___CSS_LOADER_EXPORT___;
